import React from 'react'
import type { Fuel } from '../../../../../types'
import { createColumnHelper } from '@tanstack/react-table'
import { TranslatedText } from '@staccx/i18n'
import { formatCurrency, formatNumber } from '../../../../../utils/tableFuncs'
import { getConsolidateInvoiceDescription } from '../../../../../utils/getConsolidateInvoiceDescription'

export default function fuelReportData(chosenCompany?: string) {
  const columnHelper = createColumnHelper<Fuel>()
  return [
    columnHelper.accessor(undefined, {
      id: 'account',
      header: () => <TranslatedText i18nKey={'PERIOD'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => '2023-2024' || '',
      meta: { alignmentType: 'string' }
    }),
    columnHelper.accessor('consolidatedInvoiceAgreement', {
      id: 'consolidatedInvoiceAgreement',
      header: () => (
        <TranslatedText i18nKey={'CONSOLIDATED_AGREEMENT'}>{(value) => <span>{value}</span>}</TranslatedText>
      ),
      cell: (row) => row.getValue() || '',
      meta: { alignmentType: 'string' }
    }),
    columnHelper.accessor('amountIncVAT', {
      id: 'amountIncVAT',
      header: () => <TranslatedText i18nKey={'CURRENCY_VALUE'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => formatCurrency(row.getValue()) || '',
      meta: { alignmentType: 'number' }
    }),
    columnHelper.accessor('volume', {
      id: 'volume',
      header: () => <TranslatedText i18nKey={'VOLUME'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => formatNumber(row.getValue()) || '',
      meta: { alignmentType: 'number' }
    })
  ]
}
